import Vue from 'vue'
import Router from 'vue-router'
import homepage from '@/views/homepage/homepage'
import dashboard from '@/views/dashboard/dashboard'

// 账号相关
import login from '@/views/login/login'
import employeeAudit from '@/views/employeeAudit/employeeAudit'
import chooseCompany from '@/views/chooseCompany/chooseCompany'

// 基站相关
import layermanager from '@/views/stationmanager/layermanager'
import stationManager from '@/views/stationManager'
import stationOnMap from '@/views/stationOnMap'
import stationImport from '@/views/stationImport/stationImport'
import renewStation from '@/views/renewStation'
import informationAudit from '@/views/informationAudit/informationAudit'

// 电表相关
import ammeterlist from '@/views/ammeter/ammeterlist'
import ammeterrecord from '@/views/lookammetertask/ammeterrecord'
import batchManagement from '@/views/stationManager/batchManagement'

// 告警相关
import stationWarning from '@/views/stationManager/stationEarlywarning'
import stationAlarm from '@/views/stationManager/stationAlarm'

// 任务相关
import ammetertasklist from '@/views/lookammetertask/ammetertasklist'
import checktask from '@/views/checktask/checktask'
import repairtask from '@/views/repairtask/repairtask'

// 结费任务
import payTaskList from '@/views/payTask/payTaskList'

// 工作流
import approvalCenter from '@/views/approvalCenter/approvalCenter'
import approvalRecord from '@/views/approvalCenter/approvalRecord'
import workflowList from '@/views/approvalCenter/workflowList'
import myApplyList from '@/views/approvalCenter/myApplyList'
import applyLeave from '@/views/applyWorkflow/applyLeave'
import applyStampUse from '@/views/applyWorkflow/applyStampUse'
import applyReimbursement from '@/views/applyWorkflow/applyReimbursement'
import applyProcurement from '@/views/applyWorkflow/applyProcurement'
import applyStationAmend from '@/views/applyWorkflow/applyStationAmend'
import applyStationSetUp from '@/views/applyWorkflow/applyStationSetUp'
import applyPayTaskSetUp from '@/views/applyWorkflow/applyPayTaskSetUp'
import applyPayTaskPayment from '@/views/applyWorkflow/applyPayTaskPayment'
import applyPayEBills from '@/views/applyWorkflow/applyPayEBills'
import applyCollectEBills from '@/views/applyWorkflow/applyCollectEBills'

import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/homepage',
      name: 'homepage',
      component: homepage,
      meta: {
        title: 'homepage',
        isShowComm: true
      }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: dashboard,
      meta: {
        title: 'dashboard',
        isShowComm: true
      }
    },
    {
      path: '/stationOnMap',
      name: 'stationOnMap',
      component: stationOnMap,
      meta: {
        title: 'stationOnMap',
        isShowComm: true
      }
    },
    {
      path: '/checktask',
      name: 'checktask',
      component: checktask,
      meta: {
        title: 'checktask',
        isShowComm: true
      }
    },
    {
      path: '/repairtask',
      name: 'repairtask',
      component: repairtask,
      meta: {
        title: 'repairtask',
        isShowComm: true
      }
    },
    {
      path: '/renewStation',
      name: 'renewStation',
      component: renewStation,
      meta: {
        title: 'renewStation',
        isShowComm: true
      }
    },
    {
      path: '/stationManager',
      name: 'stationManager',
      component: stationManager,
      meta: {
        title: 'stationManager',
        isShowComm: true
      },
      children: [
        {
          path: 'layermanager',
          component: layermanager,
          meta: {
            title: 'layermanager',
            isShowComm: true
          },
          children: [
            {
              path: 'HelloWorld',
              component: HelloWorld
            }
          ]
        }
      ]
    },
    {
      path: '/stationImport',
      name: 'stationImport',
      component: stationImport,
      meta: {
        title: 'stationImport',
        isShowComm: true
      }
    },
    {
      path: '/batchManagement',
      name: 'batchManagement',
      component: batchManagement,
      meta: {
        title: 'batchManagement',
        isShowComm: true
      }
    },
    {
      path: '/layermanager',
      name: 'layermanager',
      component: layermanager,
      meta: {
        title: 'layermanager',
        isShowComm: true
      }
    },
    {
      path: '/HelloWorld',
      name: 'HelloWorld',
      component: HelloWorld,
      meta: {
        title: 'HelloWorld',
        isShowComm: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta: {
        title: 'login',
        isShowComm: false
      }
    },
    {
      path: '/ammeterlist',
      name: 'ammeterlist',
      component: ammeterlist,
      meta: {
        title: 'ammeterlist',
        isShowComm: true
      }
    },
    {
      path: '/ammetertasklist',
      name: 'ammetertasklist',
      component: ammetertasklist,
      meta: {
        title: 'ammetertasklist',
        isShowComm: true
      }
    },
    {
      path: '/paytasklist',
      name: 'payTaskList',
      component: payTaskList,
      meta: {
        title: 'payTaskList',
        isShowComm: true
      }
    },
    {
      path: '/my_apply_list',
      name: 'my_apply_list',
      component: myApplyList,
      meta: {
        title: 'my_apply_list',
        isShowComm: true
      }
    },
    {
      path: '/apply_leave',
      name: 'apply_leave',
      component: applyLeave,
      meta: {
        title: 'apply_leave',
        isShowComm: true
      }
    },
    {
      path: '/apply_stamp_use',
      name: 'apply_stamp_use',
      component: applyStampUse,
      meta: {
        title: 'apply_stamp_use',
        isShowComm: true
      }
    },
    {
      path: '/apply_reimbursement',
      name: 'apply_reimbursement',
      component: applyReimbursement,
      meta: {
        title: 'apply_reimbursement',
        isShowComm: true
      }
    },
    {
      path: '/apply_procurement',
      name: 'apply_procurement',
      component: applyProcurement,
      meta: {
        title: 'apply_procurement',
        isShowComm: true
      }
    },
    {
      path: '/apply_station_amend',
      name: 'apply_station_amend',
      component: applyStationAmend,
      meta: {
        title: 'apply_station_amend',
        isShowComm: true
      }
    },
    {
      path: '/apply_station_set_up',
      name: 'apply_station_set_up',
      component: applyStationSetUp,
      meta: {
        title: 'apply_station_set_up',
        isShowComm: true
      }
    },
    {
      path: '/apply_pay_task_set_up',
      name: 'apply_pay_task_set_up',
      component: applyPayTaskSetUp,
      meta: {
        title: 'apply_pay_task_set_up',
        isShowComm: true
      }
    },
    {
      path: '/apply_pay_task_payment',
      name: 'apply_pay_task_payment',
      component: applyPayTaskPayment,
      meta: {
        title: 'apply_pay_task_payment',
        isShowComm: true
      }
    },
    {
      path: '/apply_collect_e_bills',
      name: 'apply_collect_e_bills',
      component: applyCollectEBills,
      meta: {
        title: 'apply_collect_e_bills',
        isShowComm: true
      }
    },
    {
      path: '/apply_pay_e_bills',
      name: 'apply_pay_e_bills',
      component: applyPayEBills,
      meta: {
        title: 'apply_pay_e_bills',
        isShowComm: true
      }
    },
    {
      path: '/approval_center',
      name: 'approvalCenter',
      component: approvalCenter,
      meta: {
        title: 'approvalCenter',
        isShowComm: true
      }
    },
    {
      path: '/approval_record',
      name: 'approvalRecord',
      component: approvalRecord,
      meta: {
        title: 'approvalRecord',
        isShowComm: true
      }
    },
    {
      path: '/workflow_list',
      name: 'workflow_list',
      component: workflowList,
      meta: {
        title: 'workflow_list',
        isShowComm: true
      }
    },
    {
      path: '/ammeterrecord',
      name: 'ammeterrecord',
      component: ammeterrecord,
      meta: {
        title: 'ammeterrecord',
        isShowComm: true
      }
    },
    {
      path: '/informationAudit',
      name: 'informationAudit',
      component: informationAudit,
      meta: {
        title: 'informationAudit',
        isShowComm: true
      }
    },
    {
      path: '/',
      name: 'chooseCompany',
      component: chooseCompany,
      meta: {
        title: 'chooseCompany',
        isShowComm: false
      }
    },
    {
      path: '/employeeAudit',
      name: 'employeeAudit',
      component: employeeAudit,
      meta: {
        title: 'employeeAudit',
        isShowComm: true
      }
    },
    {
      path: '/stationWarning',
      name: 'stationWarning',
      component: stationWarning,
      meta: {
        title: 'stationWarning',
        isShowComm: true
      }
    },
    {
      path: '/stationAlarm',
      name: 'stationAlarm',
      component: stationAlarm,
      meta: {
        title: 'stationAlarm',
        isShowComm: true
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js